import { Injectable } from '@angular/core';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import 'rxjs/add/observable/throw';
import 'rxjs/add/operator/map';
import { map } from 'rxjs/operators';
import 'rxjs/Rx';
import '../../shared/helpers/rxjs-extensions';

@Injectable()
export class LoggingService {
  constructor(private http: HttpClient) {
  }

  public logError(message: string) {
    const url = `${window.location.origin}/api/logging/logError?message=${message}`;
    this.http.get(url)
      .pipe(map(x => {
       // console.log(x);
      }))
      .toPromise();
   }
  public LogInformation(message: string) {
    const url = `${window.location.origin}/api/logging/LogInformation?message=${message}`;
    this.http.get(url)
      .pipe(map(x => {
       // console.log(x);
      }))
      .toPromise();
  }
  public LogWarning(message: string) {
    const url = `${window.location.origin}/api/logging/LogWarning?message=${message}`;
    this.http.get(url)
      .pipe(map(x => {
      //  console.log(x);
      }))
      .toPromise();
  }
  public LogDebug(message: string) {
    const url = `${window.location.origin}/api/logging/LogDebug?message=${message}`;
    this.http.get(url)
      .pipe(map(x => {
       // console.log(x);
      }))
      .toPromise();
  }
  public LogTrace(message: string) {
    const url = `${window.location.origin}/api/logging/LogTrace?message=${message}`;
    this.http.get(url)
      .pipe(map(x => {
       // console.log(x);
      }))
      .toPromise();
  }

}
